import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LossItem from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LossItem);
